import React from 'react'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'

const PropinaDetails = ({ payments }: {
    payments: {
        label: string;
        amount: number;
        date: string;
    }[]
}) => {
    return (
        <Detail>
            <DetailIcon name='handCoin' />
            <DetailContent>
                <DetailRow>
                    <DetailText>
                        Propinas
                    </DetailText>
                </DetailRow>
                {
                    payments.map((p) => (
                        <>
                            <DetailRow>
                                <DetailText type='bold'>
                                    {p.label}
                                </DetailText>
                                <DetailText type='bold' textAlign='right'>
                                    {formatCurrencyToFixed(p.amount)}
                                </DetailText>
                            </DetailRow>
                            <DetailRow>
                                <DetailText>
                                    {p.date}
                                </DetailText>
                            </DetailRow>
                        </>

                    ))
                }

            </DetailContent>
        </Detail>
    )
}

export default PropinaDetails